module.exports = require("prismjs/components/prism-markup-templating.js");